import { useCookies } from "@vueuse/integrations/useCookies";
import router from "@/router";

const useErrors = () => {
  const cookies = useCookies();

  const unauthorized = () => {
    if (cookies.get("session-lipmance")) {
      cookies.remove("session-lipmance");
      router.push({ name: "Login" });
    }
  };

  return { unauthorized };
};

export default useErrors;
